<template>
  <div
    class="pointer"
    @click="click"
  >
    <font-awesome-icon
      :class="classObject"
      icon="expand-arrows-alt"
    />
  </div>
</template>

<script>
import screenfull from 'screenfull'

export default {
  name: 'FullScreen',
  props: {
    width: {
      type: Number,
      default: 22,
    },
    height: {
      type: Number,
      default: 22,
    },
    fill: {
      type: String,
      default: '#FFFFFF',
    },
  },
  data() {
    return {
      isFullscreen: false,
    }
  },
  computed: {
    classObject() {
      return {
        fill: this.fill,
        width: this.width,
        height: this.height,
      }
    },
  },
  methods: {
    click() {
      if (!screenfull.enabled) {
        this.$message({
          message: this.$t('error.fullscreenNotSupported'),
          type: 'warning',
        })
        return false
      }
      return screenfull.toggle()
    },
  },
}
</script>
